module.exports = __webpack_public_path__ + "img/quick-and-easy-chocolate-cake.76017774.jpg";